import { caseTypeLabel, normalizeCaseTypes } from '../../utils/caseTypes';

// Areas of proficiency as case-type chips: `key` is the canonical slug (or the
// stored words for a value outside the vocabulary, kept as typed), `label` is
// what a person reads. One chip per case type, in stored order.
export function proficiencyChips(values) {
  return normalizeCaseTypes(values).map((key) => ({
    key,
    label: caseTypeLabel(key),
  }));
}
